export const isUserOnline = async (is_online) => {
  const entity = "user";
  const endPoint = `${process.env.REACT_APP_URL}/${entity}/change-online-status`;
  const user = JSON.parse(localStorage.getItem("user"));
  const token = localStorage.getItem("token");
  if (user && user.id) {
    const response = await fetch(`${endPoint}`, {
      method: "POST",
      keepalive: true,
      body: JSON.stringify({
        id: user.id,
        is_online,
      }),
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${token}`,
      },
    });
    const record = await response.json();
    localStorage.setItem("user", JSON.stringify(record.user));
  }
};
